export default function BunkBedIcon({ className }) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="128.000000pt"
      height="128.000000pt"
      viewBox="0 0 128.000000 128.000000"
      preserveAspectRatio="xMidYMid meet"
      className={className}
    >
      <g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)">
        <path
          d="M12 1228 c-9 -9 -12 -144 -12 -589 0 -492 2 -578 15 -589 24 -20 54
 -3 61 36 l6 34 558 0 558 0 6 -34 c7 -39 37 -56 61 -36 13 11 15 97 15 589 0
 602 0 601 -42 601 -28 0 -38 -40 -38 -146 l0 -94 -419 0 -419 0 -6 44 c-14 90
 -60 118 -187 114 l-84 -3 -10 40 c-11 42 -39 57 -63 33z m256 -160 c7 -7 12
 -25 12 -40 l0 -28 -100 0 -100 0 0 33 c0 19 3 37 7 40 12 12 168 8 181 -5z
 m652 -208 l0 -60 -420 0 -420 0 0 60 0 60 420 0 420 0 0 -60z m280 0 l0 -60
 -100 0 -100 0 0 60 0 60 100 0 100 0 0 -60z m-280 -300 l0 -160 -279 0 -279 0
 -6 44 c-14 90 -68 121 -200 114 l-76 -3 0 82 0 83 420 0 420 0 0 -160z m280
 100 l0 -60 -100 0 -100 0 0 60 0 60 100 0 100 0 0 -60z m0 -200 l0 -60 -100 0
 -100 0 0 60 0 60 100 0 100 0 0 -60z m-932 8 c7 -7 12 -25 12 -40 l0 -28 -100
 0 -100 0 0 33 c0 19 3 37 7 40 12 12 168 8 181 -5z m652 -208 l0 -60 -420 0
 -420 0 0 60 0 60 420 0 420 0 0 -60z m280 0 l0 -60 -100 0 -100 0 0 60 0 60
 100 0 100 0 0 -60z"
        />
      </g>
    </svg>
  );
}
